/**
 * Maps navigation item keys to sidebar folder open/closed state keys.
 * Preserves legacy camelCase keys from pre-dynamic sidebar localStorage.
 */
const FOLDER_KEY_ALIASES: Record<string, string> = {
  crm: 'crm',
  design: 'design',
  pdq: 'pdq',
  sales: 'reporting',
  'design-development': 'designDevelopment',
  'product-development': 'pim',
  'project-management': 'projectManagement',
  install: 'install',
  operations: 'machines',
  'sales-history': 'salesHistory',
  'order-entry': 'orderEntry',
  admin: 'admin',
  'sales.admin': 'salesAdmin',
  'sales.inquiries': 'inquiries',
  'sales.workflow': 'salesWorkflow',
  'sales.order-routing': 'orderRouting',
  'sales.order-intake': 'orderIntake',
  'sales.product-requests': 'productRequests',
  'sales.install-requests': 'installRequests',
  'install.site-surveys': 'surveys',
  'operations.reports': 'operationsReports',
}

export function navigationFolderKey(itemKey: string): string {
  if (FOLDER_KEY_ALIASES[itemKey]) {
    return FOLDER_KEY_ALIASES[itemKey]
  }

  return itemKey
    .split(/[.-]/)
    .map((part, index) => (index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)))
    .join('')
}
